import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.regexp.to-string.js";

import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  name: 'OtherInformation',
  data: function data() {
    return {
      testData: {
        'HV-meter': {
          Freq: 59.98,
          I_a: 0.21,
          I_b: 0.24,
          I_c: 0.24,
          KVAR_tot: 4.69,
          KVA_tot: -4.19,
          P: -2.1,
          Vll_ab: 11.48,
          Vll_bc: 11.76,
          Vll_ac: 11.93,
          Vln_a: 11.48,
          Vln_b: 11.76,
          Vln_c: 11.93,
          I_n: 0,
          SBSPM: 0,
          PF: -0.47,
          kWh: 23494,
          CH_kWh: 37230
        },
        'LV-meter': {
          I_a: 0.21,
          I_b: 0.24,
          I_c: 0.24,
          I_n: 0,
          Vln_a: 11.48,
          Vln_b: 11.76,
          Vln_c: 11.93,
          Vll_ab: 11.48,
          Vll_bc: 11.76,
          Vll_ac: 11.93,
          SBSPM: 0,
          Freq: 59.98,
          P: -2.1,
          KVAR_tot: 4.69,
          KVA_tot: -4.19,
          PF: -0.47,
          kWh: 23494,
          CH_kWh: 37230
        },
        風速計: {
          Vll_ab: 11.48,
          Vll_bc: 11.76,
          Vll_ac: 11.93,
          SBSPM: 0,
          Freq: 59.98,
          P: -2.1,
          KVAR_tot: 4.69,
          KVA_tot: -4.19,
          PF: -0.47,
          kWh: 23494,
          CH_kWh: 37230
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryData'])), {}, {
    urlSiteName: function urlSiteName() {
      return this.$route.query.siteName;
    },
    otherInfoData: function otherInfoData() {
      var _this = this,
        _siteData$,
        _siteData$2;
      var siteData = this.factoryData.filter(function (x) {
        return (x === null || x === void 0 ? void 0 : x.factoryName) === _this.urlSiteName;
      } // 用 factoryName 去比對，不用 displaySiteName，展示案場無此頁
      );

      // 有 detail.etc 或 detail.Anemometer
      if (siteData !== null && siteData !== void 0 && siteData.length && (siteData !== null && siteData !== void 0 && (_siteData$ = siteData[0]) !== null && _siteData$ !== void 0 && _siteData$.etc || siteData !== null && siteData !== void 0 && (_siteData$2 = siteData[0]) !== null && _siteData$2 !== void 0 && _siteData$2.Anemometer)) {
        var _siteData$3, _Object$keys;
        var dataKeyList = ['HV-meter', 'LV-meter', 'Sepam S40', 'Shihlin SPM3'
        // 可能有多個
        // 'Multimeters01',
        // 'Multimeters02',...
        // 'ProtectionRelay01'
        // 'ProtectionRelay02'...
        ];
        var data = Object.keys(siteData[0].etc).filter(function (dataKey) {
          return dataKeyList.includes(dataKey) || dataKey.includes('Multimeters') || dataKey.includes('ProtectionRelay');
        }).reduce(function (accu, curr) {
          if (!accu[curr]) accu[curr] = siteData[0].etc[curr];
          return accu;
        }, {});

        // 有風速計 可能是單一數值 或 陣列 ex: 3.3 or [3.3,2.8,...]
        var anemometer = siteData === null || siteData === void 0 ? void 0 : (_siteData$3 = siteData[0]) === null || _siteData$3 === void 0 ? void 0 : _siteData$3.Anemometer;
        if (typeof anemometer === 'number') {
          // 單一數值
          data['Anemometer'] = {
            Anemometer: anemometer
          };
        } else if (Array.isArray(anemometer)) {
          // 陣列數值
          data['Anemometer'] = anemometer.reduce(function (accu, curr, index) {
            accu['Anemometer' + (index + 1).toString().padStart(2, '0')] = curr;
            return accu;
          }, {});
        }
        return (_Object$keys = Object.keys(data)) !== null && _Object$keys !== void 0 && _Object$keys.length ? data : null; // data 可能有 etc list 或 anemometer (list) 也可能都沒有
      }
      return null;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncLastSingleDoc'])), mapMutations(['ADD_QUERY_SITE_NAME'])),
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this2.factoryData.length) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this2.asyncLastSingleDoc(_this2.urlSiteName);
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};